import { createSeniorFlowTab } from './seniorFlowTabFactory';
import { waitingToScheduleColumn } from './WaitingToScheduleCell';
import { registerTab } from './tabRegistry';

// senior_level_flow — "Ready to Schedule" tab (shown to the TA as
// "Schedule", per the flow-statuses API's own tabs[].name — the underlying
// status string this registers under stays "Ready to Schedule"; only the
// tab bar's label changed). manual_actions: assign_slot,
// mark_not_interested.
// This tab alone also gets "Waiting to Schedule" (days since row.updated_at)
// — the whole point of this tab is deciding who to schedule next, and how
// long someone's been sitting here is the signal that drives that.
const SeniorReadyToScheduleTab = createSeniorFlowTab(
  'Ready to Schedule',
  'No candidates are ready to schedule right now.',
  { extraColumns: [waitingToScheduleColumn] }
);

registerTab({
  stateMachineKey: 'senior_level_flow',
  state: 'Ready to Schedule',
  component: SeniorReadyToScheduleTab,
});

export default SeniorReadyToScheduleTab;
